export default {
    menu: {
        owner: ['clubs', 'requests', 'data', 'authority', 'disband'],
        member: ['clubs', 'data', 'quit'],
    },
}
